import { CardContent, Grid } from '@mui/material';
import { Fragment } from 'react';
import { WsTypoColors, WsTypoVariants, WsTypography } from 'wisestep-base';

import RevenueDTO from './RevenueDTO';

interface IBasicDetailsCard {
  revenue: RevenueDTO;
}

const BasicDetailsCard = ({ revenue }: IBasicDetailsCard) => (
  <Fragment>
    <CardContent>
      <Grid container sx={{ marginBottom: 2 }}>
        <WsTypography variant={WsTypoVariants.TITLE}>Details</WsTypography>
      </Grid>
      <Grid container spacing={2} xs={12}>
        <Grid item xs={6}>
          <WsTypography color={WsTypoColors.BLACK}>Fee Arrangement</WsTypography>
        </Grid>
        <Grid item xs={6}>
          <WsTypography color={WsTypoColors.BLACK}>{revenue.feeArrangementName}</WsTypography>
        </Grid>
        <Grid item xs={6}>
          <WsTypography color={WsTypoColors.BLACK}>Arrangement Type</WsTypography>
        </Grid>
        <Grid item xs={6}>
          <WsTypography color={WsTypoColors.BLACK}>{revenue.arrangementType}</WsTypography>
        </Grid>
        <Grid item xs={6}>
          <WsTypography color={WsTypoColors.BLACK}>Number Of Position</WsTypography>
        </Grid>
        <Grid item xs={6}>
          <WsTypography color={WsTypoColors.BLACK}>{revenue.numberOfPosition}</WsTypography>
        </Grid>
        {revenue.arrangementType === 'CONTRACT' && (
          <>
            <Grid item xs={6}>
              <WsTypography color={WsTypoColors.BLACK}>Contract Duration</WsTypography>
            </Grid>
            <Grid item xs={6}>
              <WsTypography color={WsTypoColors.BLACK}>
                {revenue.jobDuration} {revenue.jobDurationTimeSpan}
              </WsTypography>
            </Grid>
            <Grid item xs={6}>
              <WsTypography color={WsTypoColors.BLACK}>Standard Contract</WsTypography>
            </Grid>
            <Grid item xs={6}>
              <WsTypography color={WsTypoColors.BLACK}>
                {revenue.standardContract} Months
              </WsTypography>
            </Grid>
          </>
        )}
      </Grid>
    </CardContent>
  </Fragment>
);

export default BasicDetailsCard;
